// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__19Kkz","header2":"Header_header2__2hnNW","logo":"Header_logo__fFSd_","login":"Header_login__1rPaH"};